"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyMemberHistoryCondition = void 0;
/**
 * Significant health conditions for a person related to the patient relevant in the context of care for the patient.
 */
var FamilyMemberHistoryCondition = /** @class */ (function () {
    function FamilyMemberHistoryCondition() {
    }
    return FamilyMemberHistoryCondition;
}());
exports.FamilyMemberHistoryCondition = FamilyMemberHistoryCondition;
